import { IConversationInfoEvent, IMessage } from '@dxp/core/models';

export const hasConversationInfoChanged = (
    existing: IConversationInfoEvent,
    updated: IConversationInfoEvent,
): boolean => {
    return (
        existing.ronaTimerExpiresAt !== updated.ronaTimerExpiresAt ||
        existing.transferInitiatedBy !== updated.transferInitiatedBy ||
        existing.transferStatus !== updated.transferStatus ||
        existing.transferTimerExpiresAt !== updated.transferTimerExpiresAt ||
        existing.transferTimerStartsAt !== updated.transferTimerStartsAt ||
        existing.transferredTo !== updated.transferredTo ||
        existing.transferee !== updated.transferee
    );
};

export const sortByCreatedAsc = (messages: IMessage[]): IMessage[] => {
    return [...messages].sort(
        (a, b) =>
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    );
};

export const dedupeById = (messages: IMessage[]): IMessage[] => {
    const seen = new Set<string | undefined>();
    const out: IMessage[] = [];
    for (const m of messages) {
        if (!m) continue;
        if (seen.has(m.id)) continue;
        seen.add(m.id);
        out.push(m);
    }
    return out;
};

export function areMessagesEquivalent(
    a: readonly IMessage[] | undefined,
    b: readonly IMessage[] | undefined,
): boolean {
    if (a === b) return true;

    if (!a || !b) return false;

    const length = a.length;
    if (length !== b.length) return false;

    for (let i = 0; i < length; i++) {
        if (a[i].id !== b[i].id) {
            return false;
        }
    }

    return true;
}
